import React, { useEffect } from 'react'

import ChevronUpIcon from '~/images/icons/SystemOutlined/ChevronUp.svg'

export type ProgressProps = {
  progress: number // percentage complete
  height?: number
  color?: string
  bgColor?: string
  delay?: number // animation delay in ms
  marker?: {
    position: number // percentage of the marker
    label: React.ReactNode
  }
}
export const ProgressBar = ({ progress, color, height = 8, delay = 0, marker, bgColor }: ProgressProps) => {
  const [progressWidth, setProgressWidth] = React.useState(0)

  useEffect(() => {
    setProgressWidth(progress)
  }, [progress])

  return (
    <div className='w-full relative flex flex-col' data-name='progress_bar'>
      <div
        className={`rounded-full flex relative ${bgColor || 'bg-neutral-warm-90'} overflow-hidden`}
        style={{ height: `${height}px` }}
      >
        <div
          data-name='progress'
          className={`w-0 absolute inset-0 transition-all duration-700`}
          style={{ width: `${progressWidth}%`, backgroundColor: color, animationDelay: `${delay}ms` }}
        ></div>
        {marker && (
          <div
            data-name='progress_marker'
            className={`absolute inset-0 w-[2px]`}
            style={{ left: `${marker?.position}%`, backgroundColor: color }}
          ></div>
        )}
      </div>

      {marker && (
        <div className={`relative h-8 mt-1`}>
          <div
            className='absolute flex flex-col justify-center items-center translate-x-[-50%]'
            style={{ left: `${marker?.position}%` }}
          >
            <ChevronUpIcon title='up' className='h-4 w-4' />
            <div className='uppercase text-xs font-semibold tracking-[1px] whitespace-nowrap'>{marker.label}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export type ProgressCompletionBarProps = {
  progress: number // percentage complete
  height?: number
}
export const ProgressCompletionBar = ({ progress, height = 18 }: ProgressCompletionBarProps) => {
  const [progressWidth, setProgressWidth] = React.useState(0)

  useEffect(() => {
    setProgressWidth(progress)
  }, [progress])
  return (
    <div
      data-name='progress'
      className='w-1 transition-all duration-700 rounded bg-yellow-gradient-2'
      style={{ width: progress ? `${progressWidth}%` : undefined, height: `${height}px` }}
    ></div>
  )
}
